export function normalizarNombreLead(nombre) {
  return String(nombre || "")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function normalizarTelefonoLead(telefono) {
  return String(telefono || "").replace(/\D/g, "");
}

export function claveDuplicadoLead(nombre, telefono) {
  const tel = normalizarTelefonoLead(telefono);
  const nom = normalizarNombreLead(nombre);
  if (!nom || !tel) return "";
  return `${nom}|${tel}`;
}

export function indiceLeadsPorClave(leads = []) {
  const map = new Map();
  leads.forEach((lead) => {
    const clave = claveDuplicadoLead(lead.nombre, lead.telefono);
    if (clave && !map.has(clave)) map.set(clave, lead.id);
  });
  return map;
}

/** Separa filas válidas en nuevas vs duplicadas (CRM + repetidas en el mismo archivo). */
export function clasificarLeadsImportacion(leadsExistentes, filasValidas, createId) {
  const porClave = indiceLeadsPorClave(leadsExistentes);
  const nuevos = [];
  const duplicados = [];

  filasValidas.forEach(({ lead, numeroFila, camposImportados }) => {
    const clave = claveDuplicadoLead(lead.nombre, lead.telefono);
    const existenteId = porClave.get(clave);
    if (existenteId) {
      duplicados.push({ lead, numeroFila, leadId: existenteId, camposImportados });
      return;
    }
    const id = createId();
    nuevos.push({ ...lead, id });
    porClave.set(clave, id);
  });

  return { nuevos, duplicados };
}
